export default __webpack_public_path__ + "img/cicJdpgN.fbafda92.svg";